import { IWebsiteLanguage } from './website-language';

export interface IWebsiteLanguagesResponse {
    available_languages: { [key: string]: string };
    languages: IWebsiteLanguage[];
    multilingual: string;
}
